import moment, { Moment } from 'moment'

/**
 * Derives an expense's due date — and ONLY from an actual rule.
 *
 * If no payment term is stored (`dueDays` null/empty/not a number), the function returns `null`
 * and the field remains empty. Previously, the payment-conditions card used
 * `moment().add(dueDays ?? 0, 'days')`: that stamped TODAY's date onto a potentially years-old
 * receipt and, because of `?? 0`, did so even when
 * no payment term existed (DMS issue db5befe6 —
 * invoice dated 22.10.2024 paid by direct debit; the displayed due date was the review date).
 *
 * The anchor is the RECEIPT DATE, not today — this is how the server has always calculated it in
 * all four places: `expenseService/updateFromAnalyzation.js`, `fileService/analyzeFile.js`,
 * `fileService/analyzeFileLegacy.ts`, and
 * `_helpers/getReceiptValuesFromXml.js`.
 *
 * A due date explicitly stated on the receipt does NOT pass through here — it comes from the
 * analysis as `data.dueDate` and always takes precedence.
 */
export const deriveDueDate = (
  dueDays: unknown,
  receiptDate?: string | Date | Moment | null,
): Moment | null => {
  if (dueDays === null || dueDays === undefined || dueDays === '') {
    return null
  }

  const days = Number(dueDays)
  if (Number.isNaN(days)) {
    return null
  }

  // Without a receipt date, today is the only remaining anchor — this affects manually created
  // expenses, whose date already defaults to today anyway.
  return (receiptDate ? moment(receiptDate) : moment()).add(days, 'days').set('hour', 12)
}

export default deriveDueDate
